(function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
	}

	document.addEventListener("shopify:section:load", function (e) {
		swiperInit();
	});

	let previousWidth = window.innerWidth;
	let previousHeight = window.innerHeight;

	window.addEventListener("resize", function () {
		const currentWidth = window.innerWidth
    const currentHeight = window.innerHeight
		const isVerticalOnly = !(currentWidth !== previousWidth) && currentHeight !== previousHeight

		if (!isVerticalOnly) {
			$(".product-section .js-media-list").each(function () {
				this.swiper.destroy();
			});
			$(".product-section .js-media-sublist").each(function () {
				this.swiper.destroy();
			});
	
			swiperInit();
		}

    previousWidth = currentWidth
    previousHeight = currentHeight
	});

	swiperInit();
})();
